import {
  SET_FIELD,
  RESET_FIELD_MAP
} from '../constants/actionTypes';

const field = (state = {}, action) => {
  switch (action.type) {
    case SET_FIELD:
      return {
        ...state,
        rowsDistance: action.payload.field?.rowsDistance ?? state.rowsDistance,
        rowsAngle: action.payload.field?.rowsAngle ?? state.rowsAngle,
        aroundPerimeter: action.payload.field?.aroundPerimeter ?? state.aroundPerimeter,
        start: action.payload?.field.start === undefined ? state.start:action.payload?.field.start,
        end: action.payload?.field.end === undefined ? state.end:action.payload?.field.end,
        areaPolygon: action.payload?.field.areaPolygon === undefined ? state.areaPolygon:action.payload?.field.areaPolygon,
        captcha: action.payload?.field.captcha ?? state.captcha
      };
      case RESET_FIELD_MAP:
        return {
          ...state,
          areaPolygon: null,
          start: null,
          end: null,
        };      
    default:
      return state;
  }
};

export default field;